import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IPaymentState } from 'Redux/Slices/Payment/PaymentSlice';

type TProps = {
  purchaseToken: string;
  userAutoAssigned: boolean;
};

export const setPurchase = (state: Draft<IPaymentState>, { payload }: PayloadAction<TProps>) => {
  state.purchase = {
    purchaseToken: payload.purchaseToken,
    userAutoAssigned: payload.userAutoAssigned,
  };
  state.updatedAt = Date.now();
};
